module.exports = __webpack_public_path__ + "static/img/2.f403d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/2.jpg
// module id = uR1W
// module chunks = 0